import { useEffect, useMemo, useState } from 'react';

import type { DocNode } from '@atlaskit/adf-schema';

import { useDocumentUpdateStatus } from '@confluence/annotation-provider-store/entry-points/DocumentUpdateStatusContext.ts';
import { fg } from '@confluence/feature-gating';

export const useADFDocument = (adf: string, isFabric: boolean): [DocNode] => {
	const { documentUpdated } = useDocumentUpdateStatus();
	const docParsed = useMemo(() => {
		let documentParsed: DocNode = {
			version: 1,
			type: 'doc',
			content: [],
		};

		if (adf && isFabric) {
			try {
				documentParsed = JSON.parse(adf);
			} catch {
				let errorString = 'Failed to parse ADF';

				if (
					adf.startsWith('<div class="error fatal-render-error">') &&
					fg('confluence_include_error_in_adf_parse_failure')
				) {
					errorString += `: ${adf}`;
				}

				throw Error(errorString);
			}
		}
		return documentParsed;
	}, [adf, isFabric]);

	const [document, setDocument] = useState(docParsed);

	useEffect(() => {
		setDocument(docParsed);
	}, [docParsed, documentUpdated]);
	return [document];
};
